import OsagoGeneralMultiplierForm from './OsagoGeneralMultiplierForm';
import OsagoGeneralMultiplierList from './OsagoGeneralMultiplierList';

export default { OsagoGeneralMultiplierList, OsagoGeneralMultiplierForm };
